export const brl = (v) =>
  v === null || v === undefined || v === "" ? "—" : Number(v).toLocaleString("pt-BR", { style: "currency", currency: "BRL", minimumFractionDigits: 2, maximumFractionDigits: 2 });

export const maskCpf = (s) => {
  const d = String(s || "").replace(/\D/g, "").slice(0, 11);
  const p = [d.slice(0, 3), d.slice(3, 6), d.slice(6, 9)].filter(Boolean).join(".");
  return d.length > 9 ? `${p}-${d.slice(9)}` : p;
};
export const cpfValid = (s) => {
  const c = String(s || "").replace(/\D/g, "");
  if (c.length !== 11 || /^(\d)\1+$/.test(c)) return false;
  return [9, 10].every((n) => { const sum = [...c.slice(0, n)].reduce((a, d, i) => a + Number(d) * (n + 1 - i), 0); return ((sum * 10) % 11) % 10 === Number(c[n]); });
};


export const num = (v, d = 0) => (v === null || v === undefined ? "—" : Number(v).toLocaleString("pt-BR", { maximumFractionDigits: d, minimumFractionDigits: d }));

export const pctFmt = (v) => (v === null || v === undefined ? "—" : `${v > 0 ? "+" : ""}${Number(v).toLocaleString("pt-BR", { maximumFractionDigits: 1 })}%`);

export const dateBR = (iso) => {
  if (!iso) return "—";
  const d = iso.length <= 10 ? new Date(`${iso}T12:00:00`) : new Date(iso);
  return d.toLocaleDateString("pt-BR");
};

export const dateTimeBR = (iso) => (iso ? new Date(iso).toLocaleString("pt-BR", { dateStyle: "short", timeStyle: "short" }) : "—");
export const maskPhone = (v) => {
  const d = (v || "").replace(/\D/g, "").replace(/^55(?=\d{10,11}$)/, "").slice(0, 11);
  if (d.length <= 2) return d;
  return d.length > 10 ? d.replace(/^(\d{2})(\d{5})(\d{0,4})/, "($1) $2-$3") : d.replace(/^(\d{2})(\d{4})(\d{0,4})/, "($1) $2-$3").replace(/-$/, "");
};


const MONTHS = ["jan", "fev", "mar", "abr", "mai", "jun", "jul", "ago", "set", "out", "nov", "dez"];
const MONTHS_FULL = ["janeiro", "fevereiro", "março", "abril", "maio", "junho", "julho", "agosto", "setembro", "outubro", "novembro", "dezembro"];
export const refShort = (ref) => (ref ? `${MONTHS[+ref.slice(5, 7) - 1]}/${ref.slice(2, 4)}` : "");
export const refLong = (ref) => (ref ? `${MONTHS_FULL[+ref.slice(5, 7) - 1]}/${ref.slice(0, 4)}` : "");

export const greeting = () => {
  const h = new Date().getHours();
  return h < 12 ? "Bom dia" : h < 18 ? "Boa tarde" : "Boa noite";
};

export const EMP_STATUS = {
  pre_admissao: { label: "Pré-admissão", cls: "bg-sky-50 text-sky-700 border-sky-200" },
  admissao_cancelada: { label: "Admissão cancelada", cls: "bg-zinc-100 text-zinc-500 border-zinc-300" },
  ativo: { label: "Ativo", cls: "bg-emerald-50 text-emerald-700 border-emerald-200" },
  ferias: { label: "Férias", cls: "bg-indigo-50 text-indigo-700 border-indigo-200" },
  afastado: { label: "Afastado", cls: "bg-amber-50 text-amber-700 border-amber-200" },
  aviso_previo: { label: "Aviso prévio", cls: "bg-orange-50 text-orange-700 border-orange-200" },
  desligado: { label: "Desligado", cls: "bg-slate-100 text-slate-600 border-slate-200" },
  inativo: { label: "Inativo", cls: "bg-zinc-100 text-zinc-500 border-zinc-300" },
};

export const REQ_STATUS_CLS = {
  recebida: "bg-sky-50 text-sky-700 border-sky-200",
  em_analise: "bg-indigo-50 text-indigo-700 border-indigo-200",
  aguardando_cliente: "bg-amber-50 text-amber-800 border-amber-300",
  aguardando_funcionario: "bg-amber-50 text-amber-800 border-amber-300",
  aguardando_empresa: "bg-orange-50 text-orange-800 border-orange-300",
  em_processamento: "bg-violet-50 text-violet-700 border-violet-200",
  processada_alterdata: "bg-violet-50 text-violet-700 border-violet-200",
  em_conferencia: "bg-blue-50 text-blue-700 border-blue-200",
  concluida: "bg-emerald-50 text-emerald-700 border-emerald-200",
  cancelada: "bg-slate-100 text-slate-500 border-slate-200",
  com_pendencia: "bg-rose-50 text-rose-700 border-rose-200",
};

export const COMP_STATUS_CLS = {
  aberta: "bg-sky-50 text-sky-700 border-sky-200",
  aguardando_processamento: "bg-amber-50 text-amber-800 border-amber-300",
  em_processamento: "bg-violet-50 text-violet-700 border-violet-200",
  em_conferencia: "bg-blue-50 text-blue-700 border-blue-200",
  pronta: "bg-emerald-50 text-emerald-700 border-emerald-200",
};

export const SLA = {
  vencido: { label: "SLA vencido", cls: "text-rose-700 bg-rose-50 border-rose-200" },
  proximo: { label: "SLA próximo", cls: "text-amber-800 bg-amber-50 border-amber-300" },
  no_prazo: { label: "No prazo", cls: "text-emerald-700 bg-emerald-50 border-emerald-200" },
  encerrada: { label: "Encerrada", cls: "text-slate-500 bg-slate-50 border-slate-200" },
};

export const PRIORITY = { urgente: "Urgente", alta: "Alta", normal: "Normal", baixa: "Baixa" };
